<template>
  <v-container class="pa-0">
    <v-layout>
      <v-flex>

        <v-list two-line class="dull">
          <v-list-tile
            v-for="(j, idx) in comp_list"
            :key = "idx"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ j.name }} ({{ j.username }}) | <span style="font-size: 12px;">{{ j.comp }}: {{ j.dept }}</span>
              </v-list-tile-title>
              <v-list-tile-sub-title style="text-align: right;">
                <v-btn small round color="primary"
                  v-for="(m, indx) in j.prop"
                  :key = "indx"
                  :outline="!m.value"
                  :disabled="m.g_role_id==memberGlobal_id"
                  @click="onClick_role(idx, m, indx)"
                >{{ m.name }}</v-btn>
                <v-btn flat icon small color="red" @click="onClick_remove(idx)">
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import TreeView from "./TreeView";
import common from "../functions/general";

export default {
  name: "ListShow",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  components: {},
  data () {
    return {
      list: [],
      memberGlobal_id: ""
    };
  },
  watch: {
    "items": {
      handler: function() {        
        // this.list = [...this.items];
        this.list = structuredClone(this.items);
      },
      deep: true
    }
  },
  methods: {
    onClick_remove (idx) {
      this.$emit("delete_item", idx);
    },
    onClick_role (idx, role, role_idx) {
      var msg = {
        idx: idx,
        role: role,
        role_idx
      };
      this.$emit("update_role", msg);
    }
  },
  mounted () {
    this.list = structuredClone(this.items);
    this.memberGlobal_id = common.Setting.getEventsMemberGlobalID();
  },
  computed: {
    comp_list: {
      get: function () {
        return this.list;
      },
      set:function(val){
        // this.$emit("input",val);
      }
    }
  }
};
</script>